import React, { useState, useEffect, useMemo, useRef } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { logout, seleccionarEmpresa } from "../login/SesionService";
import {
  idEmpresa,
  mostrarModificarContrasenha,
  username,
  verificarRol,
  administradorEmpresas,
  gestorEmpresa,
  gestionNotificacion,
  verNotificaciones,
  admin,URL,
  getAuthorizationHeader
} from "../../constans/constants";
import { botonSideBar } from "./SideBar";
import Cookies from "universal-cookie";
import { actualizaPassword } from "../usuario/UsuarioService";
import DatosUsuarioModal from "../usuario/DatosUsuarioModal";
import { Modal } from "react-bootstrap";
import { esSesionAdmin } from "../usuario/Usuario";
import { Link } from "react-router-dom";
import { themeChange } from "../../assets/js/scripts/themeChange";
import { dropdown } from "../../assets/js/scripts/dropdown";
import { dashboardMenu } from "../../assets/js/scripts/dashborad";
import { swipeActions } from "../../assets/js/scripts/swipeActions";
import axios from "axios";
import ModalNotificacion from "../notificacion/ModalNotificacion";

function Header(props) {
  const [modalDatosUsuario, setModalDatosUsuario] = useState(false);
  const [modalNotiOpen, setModalNotiOpen] = useState(false);
const [notiSeleccionada, setNotiSeleccionada] = useState(null);
const [openModal, setOpenModal] = useState(false);
const [idNotificacion, setIdNotificacion] = useState(null);
  // ------------------ NOTIFICACIONES ------------------

  const [notifications, setNotifications] = useState([]);
  const [notiOpen, setNotiOpen] = useState(false);
  const notiRef = useRef(null);

  const API_BASE = URL || "";
  const empresaIdActual = idEmpresa();
  const usernameActual = username();

  const parseFecha = (str) => {
    if (!str) return new Date();
    // Formato esperado: MM/dd/yyyy (ej: "09/17/2025")
    const parts = str.split("/");
    if (parts.length !== 3) return new Date(str); // fallback si cambia formato
    const [mm, dd, yyyy] = parts;
    return new Date(Number(yyyy), Number(mm) - 1, Number(dd));
  };

  const mapTipoToClass = (tipo) => {
    if (!tipo) return "info";
    const cod = (tipo.codigo || "").toString();
    const desc = (tipo.descripcion || "").toUpperCase();

    if (desc.includes("URGENTE")) return "danger";
    if (desc.includes("AVISO")) return "warning";
    // si querés mapear por código:
    // if (cod === "03") return "danger";
    // if (cod === "01") return "warning";

    return "info";
  };

  const mapTipoToIcon = (type) => {
    switch (type) {
      case "danger":
        return "report";
      case "warning":
        return "warning_amber";
      default:
        return "info";
    }
  };

const mapDtoToNotification = (dto) => {
  const receptor = (dto.listaUsuariosReceptores || []).find(
    (r) => r.username === usernameActual
  );
  if (!receptor) return null;

  const estadoDesc = (dto.estado?.descripcion || "").toUpperCase();
  if (estadoDesc.includes("BORRADOR")) return null;

  const type = mapTipoToClass(dto.tipo);
  const dateStr = dto.fechaEnvio || dto.fechaCreacion;
  const date = parseFecha(dateStr);

  return {
    id: dto.id,
    type,
    title: dto.titulo || "Notificación",
    description: dto.resumen || dto.desarrollo || "",
    content: dto.desarrollo || dto.resumen || "",
    date,
    unread: receptor.leida === false,
  };
};


useEffect(() => {
  const cargarNotificaciones = async () => {
    if (!empresaIdActual || !usernameActual) return;

    try {
      const url = `${API_BASE}notificaciones/listar/empresa/${empresaIdActual}/usuario/${usernameActual}`;

      const resp = await axios.get(url, getAuthorizationHeader());

      const datos = resp.data?.datos || [];

      const mapped = datos
        .map(mapDtoToNotification)
        .filter(Boolean)
        .sort((a, b) => b.date - a.date);

      setNotifications(mapped);
    } catch (error) {
      if (error.response && error.response.status === 401) {
        logout();
      } else {
        console.error("Error cargando notificaciones:", error);
      }
    }
  };

  cargarNotificaciones();
}, [API_BASE, empresaIdActual, usernameActual]);


  const unreadCount = useMemo(
    () => notifications.filter((n) => n.unread).length,
    [notifications]
  );

  const toggleNoti = () => {
    setNotiOpen((prev) => !prev);
  };

  // Cerrar dropdown de notificaciones al hacer clic fuera
  useEffect(() => {
    if (!notiOpen) return;

    const handleClickOutside = (e) => {
      if (notiRef.current && !notiRef.current.contains(e.target)) {
        setNotiOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [notiOpen]);

const handleNotificationClick = (notif, e) => {
  e.preventDefault();

  // Marcar como leída en el front
  setNotifications((prev) =>
    prev.map((n) =>
      n.id === notif.id
        ? {
            ...n,
            unread: false,
          }
        : n
    )
  );
  setIdNotificacion(notif.id);
  setOpenModal(true);
};


  // ------------------ FIN NOTIFICACIONES ------------------

  const handleInput = (e) => {
    const val = e.target.value;
    props.seleccionarEmpresa(val, props.empresasUser.empresas);
    window.location.reload(true);
  };

  const handleLogout = () => {
    logout();
  };

  const esAdmin = () => empresaIdActual !== null && empresaIdActual !== undefined;

  const nomreUsuario = () => {
    const cookies = new Cookies();
    return props.sessionData?.admin
      ? cookies.get("username")
      : props.empresasUser?.nombreCompleto;
  };

  const obtenerIniciales = () => {
    const nombreCompleto = nomreUsuario();
    if (!nombreCompleto) return "";

    const partes = nombreCompleto
      .split(" ")
      .filter((parte) => parte.length > 0);
    const inicialNombre = partes[0] ? partes[0][0].toUpperCase() : "";
    const inicialApellido = partes[1] ? partes[1][0].toUpperCase() : "";

    return `${inicialNombre}${inicialApellido}`;
  };

  const mostrarPanelAdministracion = (rolAVerificar) => {
    const rolesData = JSON.parse(localStorage.getItem("roles"));
    if (verificarRol(rolesData, esSesionAdmin() ? "admin" : rolAVerificar)) {
      return (
        !admin() && (
          <li className="nav-right__item nav-right__item-config">
            <Link to="/administracion/usuarios" className="nav-right__link">
              <span className="material-symbols-outlined">
                manage_accounts
              </span>
            </Link>
          </li>
        )
      );
    }
  };

  const mostrarPanelConfiguracion = (rolAVerificar) => {
    const rolesData = JSON.parse(localStorage.getItem("roles"));
    if (verificarRol(rolesData, esSesionAdmin() ? "admin" : rolAVerificar))
      return (
        !admin() && (
          <li className="nav-right__item nav-right__item-config">
            <Link to="/configuracion/tipo-documento" className="nav-right__link">
              <span className="material-symbols-outlined">settings</span>
            </Link>
          </li>
        )
      );
  };

  const mostrarDropdownUsuario = () => {
    if (esSesionAdmin())
      return (
        <div className="nav-right__dropdown">
          <button className="dropdown__link" onClick={handleLogout}>
            <span className="material-symbols-outlined">logout</span> Cerrar
            Sesion
          </button>
        </div>
      );
    else
      return (
        <div className="nav-right__dropdown">
          <label
            htmlFor="change-theme"
            className="dropdown__link only-mobile"
            onClick={(e) => e.stopPropagation()}
            onMouseDown={(e) => e.stopPropagation()}
          >
            <input
              type="checkbox"
              id="change-theme-mobile"
              style={{ display: "none" }}
            />
            <span
              id="change-theme-icon"
              className="material-symbols-outlined"
            >
              dark_mode
            </span>{" "}
            Cambiar tema
          </label>

          {verificarRol(JSON.parse(localStorage.getItem("roles")), esSesionAdmin() ? "admin" : gestorEmpresa) && !admin() && (
            <Link
              className="dropdown__link only-mobile"
              to="/configuracion/tipo-documento"
            >
              <span className="material-symbols-outlined"> settings </span>{" "}
              Configuraciones
            </Link>
          )}

          {verificarRol(JSON.parse(localStorage.getItem("roles")), esSesionAdmin() ? "admin" : administradorEmpresas) && !admin() && (
            <Link
              className="dropdown__link only-mobile"
              to="/administracion/usuarios"
            >
              <span className="material-symbols-outlined">
                {" "}
                manage_accounts{" "}
              </span>{" "}
              Administrar usuarios
            </Link>
          )}

          <Link className="dropdown__link" type="button" to="/mi-cuenta">
            <span className="material-symbols-outlined">person</span> Mi Cuenta
          </Link>

          {mostrarModificarContrasenha && (
            <button
              className="dropdown__link"
              type="button"
              onClick={() => actualizaPassword()}
            >
              <span className="material-symbols-outlined">key</span> Cambiar
              Contraseña
            </button>
          )}
          <button className="dropdown__link" onClick={handleLogout}>
            <span className="material-symbols-outlined">logout</span> Cerrar
            Sesion
          </button>
        </div>
      );
  };

  const empresaActual = props.empresasUser?.empresas?.find(
    (e) => String(e.id) === String(empresaIdActual)
  );

  useEffect(() => {
    themeChange();
    dashboardMenu();
    dropdown();
    swipeActions();
  }, []);

  return (
    <div>
      <Modal
        size="lg"
        centered
        show={modalDatosUsuario}
        onHide={() => setModalDatosUsuario(false)}
        keyboard={false}
      >
        <DatosUsuarioModal
          nombreUsuario={username()}
          handleClose={() => setModalDatosUsuario(false)}
          dialogTitle="Datos de usuario"
        />
      </Modal>

      <div className="main-head">
        {/* Botón para abrir el rail */}
        <button
          className="mobile__modules"
          onClick={() => props.botonSideBar(props.sideBar)}
        >
          <span className="material-symbols-outlined">apps</span>
        </button>

        {/* Botón para abrir el menú lateral */}
        <button className="mobile__toggle">
          <span className="material-symbols-outlined">menu</span>
        </button>

        <div className="main-menu">
          <nav className="nav-right">
            {/* NOTIFICACIONES */}
{verificarRol(JSON.parse(localStorage.getItem("roles")), [gestionNotificacion, verNotificaciones]) && <li
  className="nav-right__item nav-right__item-noti"
  ref={notiRef}
>
  <button className="nav-right__link" onClick={toggleNoti}>
    <span className="material-symbols-outlined">notifications</span>
    {unreadCount > 0 && <span className="badge">{unreadCount}</span>}
  </button>

  <div
    className={
      "nav-right__dropdown dropdown-notifications" +
      (notiOpen ? " active" : "")
    }
  >
    <span className="drop-title">Notificaciones</span>

    {notifications.length === 0 && (
      <div className="notification-item no-notifications">
        <p>No tenés notificaciones</p>
      </div>
    )}

    {/* Solo muestro las primeras 4 */}
    {notifications.slice(0, 4).map((n) => (
      <a
        key={n.id}
        href="#"
        className={[
          "notification-item",
          n.type ? `type-${n.type}` : "",
          n.unread ? "unread" : "",
        ]
          .filter(Boolean)
          .join(" ")}
        onClick={(e) => handleNotificationClick(n, e)}
      >
        <div className="icon-shape">
          <span className="material-symbols-outlined">
            {mapTipoToIcon(n.type)}
          </span>
        </div>
        <div className="copy">
          <time className="date" dateTime={n.date.toISOString()}>
            {n.date.toLocaleDateString("es-ES")}
          </time>
          <h5 className="title">{n.title}</h5>
          <p className="description">{n.description}</p>
        </div>
      </a>
    ))}

    {/* Si hay más de 4, muestro "Ver todos" */}
    {notifications.length > 3 && (
      <Link
        to="/notificaciones"          // cambiá esta ruta a la que uses
        className="notification-item ver-todos"
        onClick={toggleNoti}          // opcional: cierra el dropdown
      >
        Ver todas las notificaciones
      </Link>
    )}
  </div>

  <ModalNotificacion
    open={openModal}
    onClose={() => setOpenModal(false)}
    idNotificacion={idNotificacion}
    username={username()}
  />
</li>}


            {/* Cambio de tema */}
            <li className="nav-right__item nav-right__item-theme">
              <div className="theme-switcher">
                <label className="switch">
                  <input type="checkbox" id="change-theme" />
                  <span
                    className="state-icon"
                    id="change-theme-icon"
                  ></span>
                </label>
              </div>
            </li>

            {/* Configuración */}
            {mostrarPanelConfiguracion(gestorEmpresa)}
            {mostrarPanelAdministracion(administradorEmpresas)}

            {/* Selección de Empresa */}
            {esAdmin() && (
              <li className="nav-right__item nav-right__item-company">
                <button className="nav-right__link">
                  {empresaActual?.logo ? (
                    <img
                      src={`data:image/png;base64,${empresaActual.logo}`}
                      className="img-profile"
                      alt="Descripcion de imagen"
                    />
                  ) : (
                    <span style={{ color: "#ccc" }}>Sin logo</span>
                  )}
                </button>
                <div className="nav-right__dropdown">
                  {props.empresasUser.empresas.map((empresa) => (
                    <a
                      key={empresa.id}
                      href="#"
                      className="dropdown__link"
                      onClick={(e) => {
                        e.preventDefault();
                        handleInput({ target: { value: empresa.id } });
                      }}
                    >
                      {empresa.nombre}
                    </a>
                  ))}
                </div>
              </li>
            )}

            {/* Perfil */}
            <li className="nav-right__item nav-right__item-profile">
              <button className="nav-right__link">
                <span className="lettercaps"> {obtenerIniciales()} </span>
                <div className="toggle-mobile">
                  <span className="material-symbols-outlined">
                    more_vert
                  </span>
                </div>
              </button>
              {mostrarDropdownUsuario()}
            </li>
          </nav>
        </div>
      </div>

    </div>
  );
}

Header.propTypes = {
  classes: PropTypes.object,
};

const mapDispatchToProps = (dispatch) => ({
  seleccionarEmpresa: (idEmpresa, userEmpresas) =>
    dispatch(seleccionarEmpresa(idEmpresa, userEmpresas)),
  botonSideBar: (sideBar) => dispatch(botonSideBar(sideBar)),
});

const mapStateToProps = (state) => ({
  sessionData: state.sessionData,
  empresasUser: state.empresaUser,
  roles: state.rolesData,
  sideBar: state.sideBar,
});

export default connect(mapStateToProps, mapDispatchToProps)(Header);
